<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import DoneIcon from "@/components/icon/DoneIcon.vue";
import RejectIcon from "@/components/icon/RejectIcon.vue";
import http from "@/http";
import DeleteIcon from "@/components/icon/DeleteIcon.vue";
import RestoreIcon from "@/components/icon/RestoreIcon.vue";

export default {
  name: "InitiativesView",
  components: { RestoreIcon, DeleteIcon, RejectIcon, DoneIcon },
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      search: null,
      size: 15,
      page: 1,
      stages: {
        INITIAL: { text: "Ko'rib chiqish", type: "" },
        NOT_PASSED: { text: "Rad etilgan", type: "danger" },
        PASSED: { text: "Qabul qilingan", type: "success" },
        WINNER: { text: "Goliblar", type: "success" },
      },
      school_stages:["INITIAL", "PASSED", "NOT_PASSED", "WINNER"],
      winnerStages: {
        IN_PROCESS: { text: "Jarayonda", type: "" },
        FINISHED: { text: "Tugallangan", type: "success" },
        REJECTED: { text: "Bekor qilingan", type: "danger" },
      },
      boards: [],
      selectedBoardId: null,
      stage: "WINNER",
      selectedStatus: "",
      declineForm: {
        id: null,
        title: null,
        moderator_comment: null,
      },
      declineDialog: false,
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/my-school/moderators/initiatives/votes/excel`,
      uploadUrlInvest: `${process.env.VUE_APP_BASE_API_URL}api/v1/my-school/initiatives/kapital/excel`,
      uploadUrlPdf: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      selectedInitiativeId: null,
      categoryForm: {
        category_id: null,
        social_link: null,
        stage: null,
      },
      categoryChangeDialog: false,
      updateRules: {
        category_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
      rules: {
        moderator_comment: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
      },

      categories: [],
      acceptDialog: false,
      acceptForm: {
        id: null,
        title: null,
        granted_amount: 0,
        description: null,
        category_id: null,
      },
      acceptRules: {
        title: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        granted_amount: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        description: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        category_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
      winnerDialogVisible: false,
      winnerInitiativeForm: {
        my_school_initiative_id: null,
        reject_file_id: null,
        accept_image_id: [],
        status: null,
      },
      baseUrl: process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/",
      reasonType: null,
    };
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
    selectedBoard() {
      return this.boards.find((item) => item.id === this.selectedBoardId);
    },
    userRole() {
      return this.$store.state.role;
    },
  },
  methods: {
    closeUpdate() {
      this.selectedInitiativeId = null;
      this.categoryChangeDialog = false;
      this.categoryForm.category_id = null;
      this.categoryForm.social_link = null,
      this.categoryForm.stage = null
    },
    onClickChangeCategory(initiativeId, categoryId, stage, socialLink) {
      this.selectedInitiativeId = initiativeId;
      this.categoryChangeDialog = true;
      this.categoryForm.category_id = categoryId;
      this.categoryForm.social_link = socialLink || null;
      this.categoryForm.stage = stage;
      if (!this.categories.length) {
        this.getSchoolCategories();
      }
    },
    completeUpdate() {
      this.$refs.updateForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .put(
              `api/v1/my-school/initiatives/${this.selectedInitiativeId}`,
              this.categoryForm
            )
            .then(() => {
              ElNotification.success({
                message: "Tahrirlash amalga oshirildi!",
              });
              this.getInitiatives();
              this.categoryChangeDialog = false;
            })
            .catch((error) => {
              ElNotification.error({
                message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    declineInitiative(initiative) {
      this.declineForm.id = initiative?.id;
      this.declineForm.title = initiative?.title;
      this.declineDialog = true;
    },
    acceptInitiative(initiative) {
      this.acceptForm.id = initiative?.id;
      this.acceptForm.title = initiative?.title;
      this.acceptForm.category_id = initiative?.category_id;
      this.acceptDialog = true;
      if (!this.categories.length) {
        this.getSchoolCategories();
      }
    },
    returnWinnerInitiativeInProcess(id) {
      this.winnerInitiativeForm = {
        my_school_initiative_id: id,
        reject_file_id: null,
        accept_image_id: [],
        status: "IN_PROCESS",
      };
      ElMessageBox.confirm(
        "Haqiqatdan ham jarayonga qaytarmoqchimisiz?",
        "Diqqat!",
        {
          confirmButtonText: "Ha",
          cancelButtonText: "Yo'q",
          type: "warning",
        }
      ).then(() => {
        http
          .post(
            `api/v1/my-school/initiatives/chronology/create`,
            this.winnerInitiativeForm
          )
          .then(() => {
            ElMessage.success("Tasdiqlandi");
            this.getInitiatives();
          })
          .catch((err) => {
            ElMessage.error(
              err.response.data.message || `Xatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    acceptWinnerInitiative(initiative, type = "rejected") {
      this.winnerInitiativeForm.reject_file_id = null;
      this.winnerInitiativeForm.accept_image_id = [];
      this.reasonType = type;
      this.winnerInitiativeForm.my_school_initiative_id = initiative.id;
      this.winnerInitiativeForm.status =
        type === "accept" ? "FINISHED" : "REJECTED";
      this.winnerDialogVisible = true;
    },
    closeDecline() {
      this.declineDialog = false;
      this.declineForm = {
        id: null,
        title: null,
        moderator_comment: null,
      };
    },
    closeAccept() {
      this.acceptDialog = false;
      this.acceptForm = {
        id: null,
        title: null,
        granted_amount: 0,
        description: null,
        category_id: null,
      };
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, size: val },
        })
        .then(() => {
          this.getInitiatives();
        })
        .catch(() => { });
    },
    handleCurrentChange(val) {
      this.$router
        .replace({
          query: { ...this.$route.query, page: val },
        })
        .then(() => {
          this.getInitiatives();
        })
        .catch(() => { });
    },
    getBoards() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/boards`, {
          params: { status: 1, offset: 0, limit: 1000 },
        })
        .then(({ data }) => {
          this.boards = data.boards;
          if (this.$route.query.board) {
            this.selectedBoardId = parseInt(this.$route.query.board);
          } else this.selectedBoardId = this.boards[0]?.id;

          this.getInitiatives();
        })
        .catch((err) => {
          ElNotification.error({
            message: err.response.data.message || "Doskalar yuklanmadi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1;
    },
    onChangeBoard() {
      this.currentPage = 1;
      this.$router.replace({
        query: { ...this.$route.query, page: 1, board: this.selectedBoardId },
      });
      this.getInitiatives();
    },
    onChangeStage() {
      this.currentPage = 1;
      this.$router.replace({
        query: { ...this.$route.query, page: 1, stage: this.stage },
      });
      this.getInitiatives();
    },
    onChangeStatus() {
      this.currentPage = 1;
      this.$router.replace({
        query: { ...this.$route.query, page: 1, stage: this.stage },
      });
      this.getInitiatives();
    },
    getInitiatives() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
        ? parseInt(this.$route.query.size || "")
        : this.size;

      this.$http
        .get(`api/v1/my-school/moderators/initiatives`, {
          params: {
            limit: this.size,
            offset: (this.page - 1) * this.size,
            board_id: this.selectedBoardId,
            stage: this.stage,
            search: this.search,
            status: this.selectedStatus,
          },
        })
        .then(({ data }) => {
          this.dataList = data.initiatives;
          this.totalElements = data.count;
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    completeDecline() {
      this.$refs.declineForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post(
              `api/v1/my-school/moderators/initiatives/${this.declineForm.id}/decline`,
              this.declineForm
            )
            .then(() => {
              ElNotification.success({
                message: "Rad etish amalga oshirildi!",
              });
              this.closeDecline();
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    completeAccept() {
      this.$refs.acceptForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post(
              `api/v1/my-school/moderators/initiatives/${this.acceptForm.id}/accept`,
              this.acceptForm
            )
            .then(() => {
              ElNotification.success({
                message: "Tasdiqlash amalga oshirildi!",
              });
              this.closeAccept();
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    getSchoolCategories() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/initiative-categories`, {
          params: {
            limit: 10000,
            offset: 0,
          },
        })
        .then(({ data }) => {
          this.categories = data.categories;
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadFile(forVote = false) {
      this.loading = true;
      let url;
      if (forVote) {
        url = "votes";
      } else {
        url = "initiatives/excel";
      }

      this.$http
        .get(
          `api/v1/my-school/moderators/${url}?board_id=${this.selectedBoardId}`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.$router.replace({ query: { ...this.$route.query, page: 1 } });
      this.getInitiatives();
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getInitiatives();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },

    uploadImg(event) {
      this.loading = true;
      const file = event.target.files[0];
      const image = new FormData();
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      this.loading = true;
      image.append("file", file);
      http
        .post(url, image, {
          headers: {
            Authorization: this.$store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          this.winnerInitiativeForm.accept_image_id.push(data.hashId);
        })
        .catch((err) => {
          ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleImageUpload() {
      const fileInputId = document.getElementById("fileInputRef");
      fileInputId.click();
    },
    uploadReferenceFile(initiativeId) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "application/pdf";
      input.onchange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        this.loading = true;
        const formData = new FormData();
        formData.append("file", file);
        http
          .post(
            `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
            formData,
            {
              headers: {
                Authorization: this.$store.state.accessToken,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(({ data }) => {
            return http.post(
              `api/v1/my-school/initiatives/chronology/file-upload`,
              {
                my_school_initiative_id: initiativeId,
                file_id: data.hashId,
              }
            );
          })
          .then(() => {
            ElNotification.success({
              message: "Dalolat fayli muvaffaqiyatli yuklandi!",
            });
            this.getInitiatives();
          })
          .catch((err) => {
            ElMessage.error(
              err.response?.data?.message || `Xatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
      };
      input.click();
    },
    onAcceptWinnerInitiative() {
      if (this.reasonType === "accept") {
        if (this.winnerInitiativeForm.accept_image_id.length < 2) {
          ElNotification.error("Kamida 2 ta rasm yuklanishi kerak!");
        } else if (!this.winnerInitiativeForm.reject_file_id) {
          ElNotification.error("PDF fayl yuklang!");
        } else {
          this.winnerInitiativeActions();
        }
      } else {
        this.winnerInitiativeForm.accept_image_id = [];
        if (this.winnerInitiativeForm.reject_file_id) {
          this.winnerInitiativeActions();
        } else {
          ElNotification.error("PDF fayl yuklang!");
        }
      }
    },
    winnerInitiativeActions() {
      let url;
      if (this.userRole === "admin") {
        url = `api/v1/my-school/initiatives/chronology/create`;
      } else {
        url = `api/v1/my-school/moderators/initiatives/chronology/create`;
      }
      http
        .post(url, this.winnerInitiativeForm)
        .then(() => {
          ElMessage.success("Tasdiqlandi");
          this.getInitiatives();
        })
        .catch((err) => {
          ElMessage.error(
            err.response.data.message || `Xatolik qayta urinib ko'ring`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickDeleteImage(index) {
      this.winnerInitiativeForm.accept_image_id.splice(index, 1);
    },
    onCloseDialog() {
      this.winnerDialogVisible = false;
    },
    onSuccessUploadWinnerFile(hash) {
      this.winnerInitiativeForm.reject_file_id = hash.hashId;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
    },
    onRemovePdf() {
      this.winnerInitiativeForm.reject_file_id = null;
    },
    beforePdfUpload(file) {
      if (file.type !== "application/pdf") {
        ElMessage.error("Faqat PDF fayl qabul qilinadi!");
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.getBoards();
  },
};
</script>

<template>
  <div class="school-initiatives-view" v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-space>
          <el-select size="large" v-model="selectedBoardId" style="margin-right: 10px; min-width: 180px"
            @change="onChangeBoard">
            <el-option v-for="board in boards" :key="board.id" :value="board.id" :label="board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
              " />
          </el-select>
          <el-select size="large" v-model="stage" style="margin-right: 10px; width: 160px" @change="onChangeStage">
            <el-option key="1" value="" label="Barchasi" />
            <el-option key="2" value="INITIAL" label="Yangilar" />
            <el-option key="3" value="PASSED" label="Qabul qilinganlar" />
            <el-option key="4" value="NOT_PASSED" label="Rad etilganlar" />
            <el-option key="5" value="WINNER" label="Goliblar" />
          </el-select>
          <el-select size="large" v-model="selectedStatus" style="margin-right: 10px; width: 160px"
            @change="onChangeStatus">
            <el-option key="1" value="" label="Barchasi" />
            <el-option key="2" value="IN_PROCESS" label="Jarayonda" />
            <el-option key="3" value="FINISHED" label="Tugallangan" />
            <el-option key="4" value="REJECTED" label="Bekor qilingan" />
          </el-select>
        </el-space>

        <el-space>
          <el-upload v-if="userRole === 'admin'" ref="uploadRef" class="upload-demo" :action="uploadUrlInvest"
            :headers="uploadHeader" :multiple="false" style="margin-bottom: -10px"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :limit="1" :on-exceed="onExceed" :on-success="onSuccessUpload" :on-error="onErrorUpload">
            <template #trigger>
              <el-button style="width: 100%" type="primary">
                Invest biriktirish
              </el-button>
            </template>
          </el-upload>
          <el-upload v-if="userRole === 'admin'" ref="uploadRef" class="upload-demo" :action="uploadUrl"
            :headers="uploadHeader" :multiple="false" style="margin-bottom: -10px"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :limit="1" :on-exceed="onExceed" :on-success="onSuccessUpload" :on-error="onErrorUpload">
            <template #trigger>
              <el-button style="width: 100%" type="primary">
                Excel orqali ovoz kiritish
              </el-button>
            </template>
          </el-upload>
          <el-button type="warning" @click="downloadFile(true)"><img src="@/assets/images/icons/download.svg" alt=""
              style="margin-right: 5px" />
            Ovozlarni yuklash
          </el-button>
          <el-button type="success" @click="downloadFile(false)"><img src="@/assets/images/icons/download.svg" alt=""
              style="margin-right: 5px" />
            Yuklab olish
          </el-button>
          <el-input size="large" v-model="search" style="width: 250px; margin-right: 10px" placeholder="Izlash"
            clearable @clear="onSearch">
            <template #append>
              <el-button style="display: flex" @click="onSearch"><img src="@/assets/images/icons/search.svg" alt="" />
              </el-button>
            </template>
          </el-input>
          <router-link :to="`my-school/initiative/add?board=${selectedBoard?.title +
            ' ' +
            selectedBoard?.season +
            '-mavsum ' +
            selectedBoard?.year +
            '-yil'
            }&&boardId=${selectedBoardId}`" class="el-button el-button--primary">
            Qo'shish
          </router-link>
        </el-space>
      </div>
    </div>
    <el-table :data="dataList" class="table" border height="calc(100vh - 255px)">
      <el-table-column type="expand">
        <template #default="scope">
          <div class="actions" v-if="
            ($store.state.role === 'moderator' || $store.state.role === 'region_manager') &&
            selectedBoard?.stage === 'MODERATE' &&
            scope.row.stage === 'INITIAL'
          ">
            <el-button size="default" type="primary" @click="acceptInitiative(scope.row)">
              Tasdiqlash
            </el-button>
            <el-button size="default" type="warning" @click="declineInitiative(scope.row)">
              Rad etish
            </el-button>
          </div>
          <el-empty v-else image-size="50" />
        </template>
      </el-table-column>
      <el-table-column type="index" :index="indexMethod" width="80" label="#" />
      <el-table-column prop="public_id" label="ID" min-width="150" />
      <el-table-column prop="title" label="Nomi" min-width="280" />
      <el-table-column prop="stage" label="Holati" min-width="135">
        <template #default="scope">
          <el-tag :type="stages[scope.row.stage]?.type">
            {{ stages[scope.row.stage]?.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Realizatsiya holati" min-width="135">
        <template #default="scope">
          <el-tag v-if="scope.row.stage === 'WINNER' && scope.row.status" :type="winnerStages[scope.row.status].type">
            {{ winnerStages[scope.row.status].text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="requested_amount" label="So'ralgan miqdor" min-width="150">
        <template v-slot="scope">
          {{ scope.row.requested_amount.toLocaleString("ru-RU") + " UZS" }}
        </template>
      </el-table-column>
      <el-table-column prop="granted_amount" label="Loyiha qiymati" min-width="150">
        <template v-slot="scope">
          {{ scope.row.granted_amount.toLocaleString("ru-RU") + " UZS" }}
        </template>
      </el-table-column>
      <el-table-column prop="school" label="Maktab" min-width="180" />
      <el-table-column prop="category" label="Turkum" min-width="90" />
      <el-table-column prop="author_full_name" label="Tashabbuskor" min-width="180" />
      <el-table-column align="right" label="" width="240">
        <template #default="scope">
          <el-button type="primary" size="small" @click="onClickChangeCategory(scope.row.id, scope.row.category_id, scope.row.stage, scope.row.social_link)">
            <img height="15" src="@/assets/images/icons/edit.svg" alt="action" />
          </el-button>
          <el-button v-if="scope.row.status === 'FINISHED' && !scope.row.reject_file_id" @click="uploadReferenceFile(scope.row.id)" size="small">
            Dalolat fileni yuklash
          </el-button>
          <template v-if="
            scope.row.stage === 'WINNER' &&
            scope.row.status === 'IN_PROCESS' &&
            (userRole === 'admin' || userRole === 'moderator' || userRole === 'region_manager')
          ">
            <el-button size="small" style="margin-top: 4px" type="success"
              @click="acceptWinnerInitiative(scope.row, 'accept')">
              <!--              <done-icon/>-->
              G'olib loyiha ishlarini yakunlash
            </el-button>
            <el-button style="margin-top: 4px" size="small" type="danger" @click="acceptWinnerInitiative(scope.row)">
              <!--              <reject-icon/>-->
              G'olib loyiha ishlarini rad etish
            </el-button>
          </template>
          <template v-if="
            scope.row.stage === 'WINNER' &&
            scope.row.status !== 'IN_PROCESS' &&
            userRole === 'admin'
          ">
            <el-button size="small" type="info" @click="returnWinnerInitiativeInProcess(scope.row.id)">
              <restore-icon />
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination v-model:current-page="currentPage" class="pagination" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" layout="sizes, prev, pager, next" :total="totalElements"
            v-model:page-size="size" :page-count="totalPages" :background="true"
            :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-dialog v-model="declineDialog" :title="`Rad etish (${declineForm.title})`" @close="closeDecline"
    style="max-width: 600px" align-center>
    <el-form ref="declineForm" :model="declineForm" :rules="rules" label-position="top" style="width: 500px" status-icon
      hide-required-asterisk>
      <el-form-item label="Kommentariya" prop="moderator_comment">
        <el-input v-model="declineForm.moderator_comment" type="textarea" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDecline">Bekor qilish</el-button>
        <el-button type="primary" @click="completeDecline"> Saqlash </el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="acceptDialog" title="Qabul qilish" @close="closeAccept" style="max-width: 600px" align-center>
    <el-form ref="acceptForm" :model="acceptForm" :rules="acceptRules" label-position="top" style="width: 500px"
      status-icon hide-required-asterisk>
      <!-- <el-form-item label="Nomi" prop="title">
        <el-input v-model="acceptForm.title" type="text" />
      </el-form-item> -->
      <el-form-item label="Ruxsat etiladigan qiymati" prop="granted_amount">
        <el-input-number style="width: 100%" v-model="acceptForm.granted_amount" type="number" />
      </el-form-item>
      <el-form-item label="Turkumni tanlang" prop="category_id">
        <el-select v-model="acceptForm.category_id" style="width: 100%">
          <el-option v-for="category in categories" :key="category.id" :value="category.id" :label="category.title" />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="Izohni kiriting" prop="description">
        <el-input v-model="acceptForm.description" type="textarea" />
      </el-form-item> -->
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeAccept">Bekor qilish</el-button>
        <el-button type="primary" @click="completeAccept"> Saqlash </el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="categoryChangeDialog" title="Turkumni o'zgartirish" @close="closeUpdate" style="max-width: 600px"
    align-center>
    <el-form ref="updateForm" :model="categoryForm" :rules="updateRules" label-position="top" style="width: 100%"
      status-icon hide-required-asterisk>
      <el-form-item label="Turkumni tanlang" prop="category_id">
        <el-select size="large" v-model="categoryForm.category_id" style="width: 100%">
          <el-option v-for="category in categories" :key="category.id" :value="category.id" :label="category.title" />
        </el-select>
      </el-form-item>
      <el-form-item label="Ijtimoiy tarmoq linki" prop="social_link">
        <el-input size="large" v-model="categoryForm.social_link" placeholder="https://example.com" />
      </el-form-item>
      <el-form-item label="Bosqich" prop="stage">
        <el-select v-model="categoryForm.stage" style="width: 100%">
          <el-option v-for="stage in school_stages" :key="stage" :value="stage" :label="stage" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeUpdate">Bekor qilish</el-button>
        <el-button type="primary" @click="completeUpdate"> Saqlash </el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="winnerDialogVisible" :title="`G'olib loyiha ishlarini ${reasonType === 'accept' ? ' yakunlash' : 'rad etish'
    }`" style="max-width: 600px" align-center destroy-on-close>
    <el-form ref="updateForm" :model="winnerInitiativeForm" :rules="updateRules" label-position="top"
      style="width: 100%" status-icon hide-required-asterisk>
      <span v-if="reasonType === 'accept'" class="warning-text">Kamida 2 ta rasm yuklash kerak</span>
      <el-row style="margin-bottom: 16px" v-if="reasonType === 'accept'">
        <el-col :span="24">
          <el-button id="upload_img" class="info-btn form-input" @click="handleImageUpload">
            <input type="file" id="fileInputRef" accept="image/jpeg,image/jpg,image/png" @change="uploadImg" multiple
              style="display: none" />
            <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px" />
            Rasm yuklash
          </el-button>
        </el-col>
        <div class="images">
          <div class="image-item" v-for="(imageHash, index) in winnerInitiativeForm.accept_image_id" :key="index">
            <el-image style="
                margin: 15px 0;
                height: 300px;
                width: 250px;
                border: 1px solid #e4e4e4;
                border-radius: 4px;
              " :src="baseUrl + imageHash" fit="cover" />
            <span class="delete" @click="onClickDeleteImage(index)">
              <delete-icon />
            </span>
          </div>
        </div>
      </el-row>
      <el-row style="margin-bottom: 16px" v-if="reasonType === 'accept'">
        <el-col :span="24">
          <span class="warning-text">PDF fayl yuklang</span>
          <el-upload class="upload-demo" :action="uploadUrlPdf" :headers="uploadHeader" :multiple="false"
            accept="application/pdf" :limit="1" :on-exceed="onExceed" :before-upload="beforePdfUpload"
            :on-success="onSuccessUploadWinnerFile" :on-error="onErrorUpload" :on-remove="onRemovePdf">
            <template #trigger>
              <el-button style="width: 100%" type="warning">
                Fayl yuklash
              </el-button>
            </template>
          </el-upload>
        </el-col>
      </el-row>
      <el-form-item prop="file" v-else>
        <el-upload ref="uploadRef" class="upload-demo" :action="uploadUrlPdf" :headers="uploadHeader" :multiple="false"
          accept="application/pdf" :limit="1" :on-exceed="onExceed" :before-upload="beforePdfUpload"
          :on-success="onSuccessUploadWinnerFile" :on-error="onErrorUpload" :on-remove="onRemovePdf">
          <template #trigger>
            <el-button style="width: 100%" type="warning">
              Fayl yuklash
            </el-button>
          </template>
        </el-upload>
      </el-form-item>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <el-button class="custom-btn" @click="onCloseDialog">Orqaga
            </el-button>
            <el-button class="custom-btn" type="primary" @click="onAcceptWinnerInitiative">Saqlash
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.el-button--primary {
  text-decoration: none;
}

.filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.actions {
  padding: 10px 20px;
  display: flex;
}

.upload_img {
  margin-bottom: 24px;
}

.images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image {
  &-item {
    position: relative;

    .delete {
      position: absolute;
      display: none;
      top: 20px;
      right: 5px;
      cursor: pointer;
    }

    &:hover {
      .delete {
        display: inline-block;
      }
    }
  }
}

.warning-text {
  margin-bottom: 8px;
  display: block;
  font-style: italic;
  color: #d33b52;
}
</style>
